import { X } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import { Col, Image, Modal, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import InfoIcon from '../../../assets/images/Icons/bank-white-icon.svg';
import MaskInfoIcon from '../../../assets/images/info-icon-v2.svg';
import { currencifyInDollars, MaskAccountNumber } from '../../../commonservices/CommonMethods';




const BankInformationPopup = (props) => {

    const [showMask,setShowMask] = useState(true);

        return (
        <Modal className={`default-popup modal-backdrop-bg-color default-medium-popup table-in-popup`} show={props.show}
            onHide={props.closeModal}>
            <Modal.Header className='darkblue-bg-color' closeButton={true}>
                <Modal.Title>
                    <span className='popup-title-icon'><Image src={InfoIcon} /></span>
                    <span className='flex-grow-1'>Bank Information</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
           {props?.data?.account ? (
                <div>
                    <Row className='m-0'>
                        <Col md={4} className='p-3 fundingRequestDetailsVD'>
                            <h6>Bank Details</h6>
                            <div className="w-33 mb-3">
                                <b>Name</b>
                                <p>{props?.data?.account?.bankName ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Reference</b>
                                <p>{props?.data?.sopraReference ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Routing</b>
                                <p>{props?.data?.account?.routing ?? "-N/A-"}</p>
                            </div>
                            <div>
                                <b>Account Number</b>
                                <b className='d-block'>{MaskAccountNumber(showMask, props?.data?.account?.accountNumber) } 
                                
                                <span>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>View {showMask ? 'unmasked' : 'masked'} account number.</Tooltip>}>
                                                    <Image src={MaskInfoIcon} className="ml-0 ml-2 bank-rotate-refresh cursor-pointer" onClick={(event) => {
                                                        showMask ? setShowMask(false) : setShowMask(true) ;
                                                            }} />
                                        </OverlayTrigger>
                                </span>
                                </b>
                            </div> 
                            
                            <div className="w-33 mb-3">
                                <b>Mask</b>
                                <p>{props?.data?.account?.mask ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>institution Id</b>
                                <p>{props?.data?.account?.institution_id ?? "-N/A-"}</p>
                            </div>


                        </Col>

                        <Col md={4} className='p-3 fundingRequestDetailsVD'>
                            <h6>Account Details</h6>

                            <div className="w-33 mb-3">
                                <b>Owner</b>
                                <p>{props?.data?.ownerName ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Name</b>
                                <p>{props?.data?.metadata?.account?.name ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Type</b>
                                <p>{props?.data?.metadata?.account?.type ?? "-N/A-"}</p>
                            </div>

                            <div className="w-33 mb-3">
                                <b>Sub Type</b>
                                <p>{props?.data?.metadata?.account?.subtype ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Verification Status</b>
                                <p>{props?.data?.metadata?.account?.verification_status ?? "-N/A-"}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Class Type</b>
                                <p>{props?.data?.metadata?.account?.class_type ?? "-N/A-"}</p>
                            </div>


                        </Col>

                        <Col md={4} className='p-3 fundingRequestDetailsVD'>
                            <h6>Balance Details</h6>
                            <div className="w-33 mb-3">
                                <b>Available</b>
                                <b className='d-block'>{props?.data?.account?.balances?.available ? currencifyInDollars(props?.data?.account?.balances?.available) : '0.00'}</b>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Current</b>
                                <b className='d-block'>{props?.data?.account?.balances?.current ? currencifyInDollars(props?.data?.account?.balances?.current) : '0.00'}</b>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Currency</b>
                                <p>{props?.data?.account?.balances?.iso_currency_code ?? '-N/A-'}</p>
                            </div>
                            <div className="w-33 mb-3">
                                <b>Limit</b>
                                <p>{props?.data?.account?.balances?.limit ?? '-N/A-'}</p>
                            </div>
                        </Col>
                        {/* <Col md={3} className='p-3 fundingRequestDetailsVD'>
                            <h6>Owner Details</h6>

                            <div className="w-33 mb-3">
                                <b>Owner Name</b>
                                <p>{props?.data?.ownerName}</p>
                            </div>
                        </Col> */}
                    </Row>

                </div>
                 ) : props?.data?.currentPrimaryBank && props?.data?.previousPrimaryBank && ( <Row className='m-0'>
                <Col md={6} className='p-3 fundingRequestDetailsVD'>
                    <h6 className='mb-1'> Changed Bank From</h6>
                    <div className="w-33 mb-1">
                        <b>Bank Name</b>
                        <p>{props?.data?.previousPrimaryBank?.account?.bankName ?? "-N/A-"}</p>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Account Number</b>
                        <b className='d-block'>{props?.data?.previousPrimaryBank?.account?.accountNumber ? props?.data?.previousPrimaryBank?.account?.accountNumber : "-N/A-"}</b>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Routing</b>
                        <p>{props?.data?.previousPrimaryBank?.account?.routing ?? "-N/A-"}</p>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Mask</b>
                        <p>{props?.data?.previousPrimaryBank?.account?.mask ?? "-N/A-"}</p>
                    </div> 
                </Col>

                <Col md={6} className='p-3 fundingRequestDetailsVD'>
                    <h6 className='mb-1'>Changed Bank To</h6>
                    <div className="w-33 mb-1">
                        <b>Bank Name</b>
                        <p>{props?.data?.currentPrimaryBank?.account?.bankName ?? "-N/A-"}</p>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Account Number</b>
                        <b className='d-block'>{props?.data?.currentPrimaryBank?.account?.accountNumber ? props?.data?.currentPrimaryBank?.account?.accountNumber : "-N/A-"}</b>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Routing</b>
                        <p>{props?.data?.currentPrimaryBank?.account?.routing ?? "-N/A-"}</p>
                    </div>
                    <div className="w-33 mb-1">
                        <b>Mask</b>
                        <p>{props?.data?.currentPrimaryBank?.account?.mask ?? "-N/A-"}</p>
                    </div>
                </Col>
            </Row> )
        }




            </Modal.Body>
        </Modal >
    )

}

export default BankInformationPopup;